export const INITIALIZE_SEARCH = 'initialize-search';
const initializeSearch = () => ({ type: INITIALIZE_SEARCH });
export default initializeSearch;
